import React, { useState, createContext } from 'react';

export const HooksOkr = createContext();

function Index(props) {
  const [dataObjective, setDataObjective] = useState({});
  const [isAutoComplete, setIsAutoComplete] = useState(false);
  const [showDetailTeam, setShowDetailTeam] = useState({
    member: false,
    objective: false,
    key_result: false,
    action_plan: false,
    initiative: false,
    activities: false,
    create: false,
    assign_to: false,
    edit: false,
  });
  const [typeCreateOkr, setTypeCreateOkr] = useState(2);
  const valx = {
    dataObjective,
    setDataObjective,
    isAutoComplete,
    setIsAutoComplete,
    showDetailTeam,
    setShowDetailTeam,
    typeCreateOkr,
    setTypeCreateOkr,
  };

  return <HooksOkr.Provider value={valx}>{props.children}</HooksOkr.Provider>;
}

export default Index;
